import { useState } from 'react'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Switch } from 'antd'
import { TEXT_LABEL_STYLE } from '@User/MyAccountPage/styleConstants'
import pageStyles from '@User/MyAccountPage/styles.css'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { IdentityType } from '~/redux-modules/identity/type'
import {
    useGetIs2faEnabledMyAccountQuery,
    useGetQrCodeMyAccountPageMutation,
} from '~/gql/graphql'

import MfaModal from './MfaModal'
import MfaWarningModal from './MfaWarningModal'

type MfaSectionPropsType = {
    identity: IdentityType
    queryString?: string
}

export const MFA_ENFORCE_QUERY_STRING = 'enforce2fa=true'

export default function MfaSection(props: MfaSectionPropsType) {
    const {
        identity: { id },
        queryString,
    } = props
    const [modalVisible, setModalVisible] = useState<boolean>(false)
    const [mfaWarningModalVisible, setMfaWarningModalVisible] = useState<
        boolean | undefined
    >(undefined)
    const [mfaEnabled, setMfaEnabled] = useState<boolean | undefined>(undefined)
    const [qrCode, setQrCode] = useState<null | string>(null)
    const [getQRCode] = useGetQrCodeMyAccountPageMutation()
    const { data: is2faEnabledData } = useGetIs2faEnabledMyAccountQuery()

    const is2faEnabled =
        mfaEnabled === undefined
            ? is2faEnabledData?.me?.is2faEnabled
            : mfaEnabled
    const shouldShow2faWarning =
        !is2faEnabled &&
        mfaWarningModalVisible === undefined &&
        (queryString || '').includes(MFA_ENFORCE_QUERY_STRING)
    const toggle2FA = async (toggle: boolean) => {
        if (toggle && !qrCode) {
            const { data } = await getQRCode({
                variables: {
                    id,
                },
            })

            setQrCode(data?.user?.enable2FA || '')
        }
        setModalVisible(true)
        setMfaEnabled(toggle)
    }

    return (
        <Box
            className={pageStyles.mobileColBox}
            padding="24px 0"
            marginBottom="16px"
        >
            {shouldShow2faWarning && (
                <MfaWarningModal
                    visible={shouldShow2faWarning}
                    closeModal={() => {
                        setMfaWarningModalVisible(false)
                        toggle2FA(true)
                    }}
                />
            )}
            {modalVisible && (
                <MfaModal
                    id={id}
                    qrCode={qrCode}
                    mfaEnabled={mfaEnabled}
                    visible={modalVisible}
                    closeModal={() => {
                        setModalVisible(false)
                    }}
                    setMfaEnabled={setMfaEnabled}
                />
            )}
            <Box className={pageStyles.mobileLabel}>
                <Text style={TEXT_LABEL_STYLE}>SECURITY</Text>
            </Box>
            <Box alignItems="center">
                <Switch
                    style={{ marginRight: '12px' }}
                    checked={is2faEnabled}
                    checkedChildren={
                        <CheckOutlined style={{ fontSize: '8px' }} />
                    }
                    unCheckedChildren={
                        <CloseOutlined style={{ fontSize: '8px' }} />
                    }
                    onChange={toggle2FA}
                />
                <Text>
                    Two-factor authentication{' '}
                    {is2faEnabled ? 'enabled' : 'disabled'}
                </Text>
            </Box>
        </Box>
    )
}
